import { useSearchParams } from "react-router";
import { twMerge } from "tailwind-merge";
import { useShallow } from "zustand/react/shallow";
import { SpinnerLegacy } from "../../../../../components";
import { useBasketContext } from "../../../../../hooks";
import { useStockList } from "../../../../../hooks/api/v2/stockList/useStockList";
import { useStorefrontFilterStore } from "../../../StorefrontFilterStore";
import { useStockListBasketValue } from "../../../useStockListBasketValue";
import { useStockListContext } from "../../../useStockListContext";
import { StorefrontChildProductListContent } from "./StorefrontChildProductListContent";

export const StorefrontChildProductList = ({
  className,
  productId,
}: {
  className?: string;
  productId: number;
}) => {
  const {
    selectedPriceTier,
    selectedAvailabilityTier,
    showOutOfStockProducts,
  } = useStorefrontFilterStore(
    useShallow((state) => ({
      selectedPriceTier: state.selectedPriceTier,
      selectedAvailabilityTier: state.selectedAvailabilityTier,
      showOutOfStockProducts: state.showOutOfStockProducts,
    })),
  );
  const basketTotal = useStockListBasketValue();
  const {
    supplierQuery,
    unAuthorisedUserPostcode,
    supplierStorefront,
    submittedOrder,
  } = useStockListContext();
  const [{ order }] = useBasketContext();
  const [searchParams] = useSearchParams();

  const storefrontLink =
    searchParams.get("storefrontLink") || searchParams.get("priceTierLink");

  const productsListQuery = useStockList(
    {
      ParentId: productId,
      active: true,
      SupplierId: supplierQuery.data?.id ?? 0,
      PriceTierId: selectedPriceTier,
      AvailabilityTierId: selectedAvailabilityTier,
      postcode: unAuthorisedUserPostcode,
      storefrontLinkPassword: storefrontLink ?? undefined,
      showOutOfStockProducts,
    },
    { enabled: !!supplierQuery.data?.id },
  );

  const {
    connection,
    checkoutSelectedFulfillmentType,
    courierFulfillmentType,
  } = useStockListContext();

  const getSelectedFulfilmentType = () => {
    if (checkoutSelectedFulfillmentType) {
      return checkoutSelectedFulfillmentType;
    }

    if (connection?.fulfillmentType) {
      return connection.fulfillmentType;
    }

    return "courier";
  };

  if (!supplierQuery.data?.id) return <SpinnerLegacy />;

  return (
    <div className={twMerge("md:px-2", className)}>
      <StorefrontChildProductListContent
        productsListQuery={productsListQuery}
        supplier={supplierQuery.data}
        submittedOrder={submittedOrder}
        supplierStorefront={supplierStorefront}
        basketOrder={order}
        basketTotal={basketTotal}
        selectedFulfillmentType={getSelectedFulfilmentType()}
        courierFulfillmentType={courierFulfillmentType}
      />
    </div>
  );
};
